module.exports = __webpack_public_path__ + "static/media/3040160000_03.075406f7.jpg";